// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyADWbaMTD2YdB9X3_cxOMaPPjLCmenUsUY",
  authDomain: "book-store-9b62d.firebaseapp.com",
  projectId: "book-store-9b62d",
  storageBucket: "book-store-9b62d.firebasestorage.app",
  messagingSenderId: "331023133957",
  appId: "1:331023133957:web:ef09c56054cd80533e5b6c",
  measurementId: "G-6VGZ3BX1KC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export default app;